import { CORE_SIZE } from '../../constants/index.es.js';
import { themeColor } from '../Colors/index.es.js';
import { getRgbaFromHex } from '../Colors/util.es.js';

const getBoxShadow = (props, shadow, shadowColor = "black") => {
  var _a, _b, _c;
  const css = ((_a = props.theme) == null ? void 0 : _a.shadowValue[shadow]) || "none";
  return css.replace(/{{color}}/gi, getRgbaFromHex(((_b = props.theme) == null ? void 0 : _b.colors[shadowColor]) || "", (_c = props.theme) == null ? void 0 : _c.shadowAlphaValue[shadow]) || "");
};
const defaultTheme = {
  colors: themeColor,
  borderRadius: {
    s: CORE_SIZE.s4,
    m: CORE_SIZE.s8,
    l: CORE_SIZE.s12,
    xl: CORE_SIZE.s16
  },
  borderWeight: {
    s: "0.5px",
    m: "1px",
    l: "1.5px"
  },
  opacity: {
    s: 0,
    m: 0.3,
    l: 0.5,
    xl: 0.7
  },
  shadowValue: {
    "down-xs": "0 2px 2px {{color}}",
    "down-s": "0 2px 4px {{color}}",
    "down-m": "0 4px 8px {{color}}",
    "down-l": "0 4px 16px {{color}}, 0 8px 16px {{color}}",
    "up-s": "0 -2px 4px {{color}}",
    "up-m": "0 -4px 8px {{color}}",
    "up-l": "0px -4px 16px {{color}}, 0px -8px 16px {{color}};"
  },
  shadowAlphaValue: {
    "down-xs": 0.1,
    "down-s": 0.075,
    "down-m": 0.05,
    "down-l": 0.05,
    "up-s": 0.075,
    "up-m": 0.05,
    "up-l": 0.05
  },
  spacing: CORE_SIZE,
  shadow: getBoxShadow
};

export { defaultTheme };
